import { axiosInstance } from "@/resources/requestInfo";
import { feedbackRoutes } from "@/redux/feedback/routes";

function getIpsCodes(state: any): string[] | undefined {
  return (
    state?.authAndReg?.user?.userIpsCodes ||
    state?.authAndReg?.userIpsCodes ||
    state?.getProfile?.profileInfo?.[0]?.userIpsCodes ||
    undefined
  );
}

function getBrowserInfo() {
  if (typeof window === 'undefined') {
    return {};
  }

  return {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    url: window.location.href,
    pathname: window.location.pathname,
    cookieEnabled: navigator.cookieEnabled,
    timestamp: new Date().toISOString(),
  };
}

export async function loggerSendingData({
  type,
  data,
  state,
}: {
  type: string;
  data: any;
  state?: any;
}): Promise<void> {
  try {
    const ipCode = state ? getIpsCodes(state) : undefined;

    const browserInfo = getBrowserInfo();

    const dataTemp = {
      ...data,
      extraInfo: {
        platform: "web",
        IPCode: ipCode,
        browser: browserInfo,
        sessionId: getSessionId(),
      },
    };

    await axiosInstance.post(feedbackRoutes.LOGGER_SENDING_DATA, {
      type,
      data: dataTemp,
    });
  } catch (error: any) {
    console.warn("Logger error (non-critical):", error);
  }
}

function getSessionId(): string {
  if (typeof window === 'undefined') {
    return 'server-side';
  }

  const STORAGE_KEY = 'session_id';
  let sessionId = sessionStorage.getItem(STORAGE_KEY);

  if (!sessionId) {
    sessionId = `web_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
    sessionStorage.setItem(STORAGE_KEY, sessionId);
  }

  return sessionId;
}
